import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Schema for a single data point in the revenue per customer time series
 */
const revenueChartPointSchema_ = z.object({
  /** Date of the data point */
  date: zExt.plainDate(),
  /** Variant group revenue per customer for this period */
  variant: z.number(),
  /** Control group revenue per customer for this period */
  control: z.number(),
});
export const revenueChartPointSchema: z.ZodType<RevenueChartPoint> =
  revenueChartPointSchema_;
export interface RevenueChartPoint
  extends z.infer<typeof revenueChartPointSchema_> {}

const revenueChartOutputSchema_ = z.object({
  /** Time series data points for the chart */
  data: z.array(revenueChartPointSchema),
});
export const revenueChartOutputSchema: z.ZodType<RevenueChartOutput> =
  revenueChartOutputSchema_;
export interface RevenueChartOutput
  extends z.infer<typeof revenueChartOutputSchema_> {}

export const getMarketingAgentRevenueChart = {
  name: "getMarketingAgentRevenueChart" as const,
  input: z.object({
    /** Number of days to include in the chart */
    days: z.number().int().positive(),
    splitId: z.string().optional(),
  }),
  output: revenueChartOutputSchema.nullable(),
};
